import React from "react";

/**
 * Brand Component
 * @param props
 */
export const WABrand: React.FC<{}> = props => (
  <div className="wa-header-brand">{props.children}</div>
);
